import { Component, Input, OnInit } from '@angular/core'
import { MBTI } from 'src/app/interfaces/mbti'
import { GeneralService } from 'src/app/services/general/general.service'
import { LogService } from 'src/app/services/log/log.service'
import { BestSurveyItem } from '../../../../interfaces/survey'
import { SurveyService } from '../../../../services/survey/survey.service'

@Component({
  selector: 'ideal-type-survey-list',
  templateUrl: './ideal-type-survey-list.component.html',
  styleUrls: ['./ideal-type-survey-list.component.scss'],
})
export class IdealTypeQuizSurveyListComponent implements OnInit {
  constructor(
    private generalService: GeneralService,
    private logService: LogService,
    private surveyService: SurveyService
  ) { }

  @Input() targetMbti: MBTI | undefined
  @Input() compareMbti: MBTI | undefined
  @Input() showTitle?: boolean = true
  oppositeSurveyList: BestSurveyItem[] = []
  similarSurveyList: BestSurveyItem[] = []

  ngOnInit(): void {
    if (this.targetMbti) {
      this.surveyService.getBestSurveyList('opposite', this.targetMbti, this.compareMbti ?? null).subscribe((res) => {
        if (res.data) {
          this.oppositeSurveyList = res.data
        }
      })
      if (this.compareMbti !== undefined) {
        this.surveyService.getBestSurveyList('similar', this.targetMbti, this.compareMbti ?? null).subscribe((res) => {
          if (res.data) {
            this.similarSurveyList = res.data
          }
        })
      }
    }
  }

  async onClickSurveyItem(content: string, type: string): Promise<void> {
    this.logService.idealTypeQuiz.quizReportSurveyItemClicked(content, type)
  }

  async onClickAllSurvey(): Promise<void> {
    this.logService.idealTypeQuiz.quizReportAllSurveyButtonClicked()
  }
}
